/* src/app/admin-dashboard/delivery/overview/overview.component.css */
.do-wrap {
  padding: 16px;
}
.do-spacer {
  flex: 1 1 auto;
}
.do-muted {
  color: #888;
  font-size: 12px;
}
.do-empty {
  padding: 18px;
  text-align: center;
  color: #888;
  font-size: 13px;
}
.do-toolbar {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: space-between;
}
.do-title {
  margin: 0 0 2px;
  font-size: 19px;
  font-weight: 600;
  text-transform: capitalize;
}
.do-note {
  margin: 0;
  color: #555;
  font-size: 13px;
  max-width: 680px;
}
.do-date {
  display: flex;
  align-items: center;
  gap: 4px;
}
.do-date-field {
  width: 160px;
}
.do-date-field .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.do-stats {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin: 12px 0 16px;
}
.do-stat {
  flex: 1 1 130px;
  min-width: 120px;
  background: #fff;
  border: 1px solid #e3e6ea;
  border-radius: 8px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.do-stat-num {
  font-size: 22px;
  font-weight: 700;
  color: #2d3b45;
  line-height: 1.1;
}
.do-stat-label {
  font-size: 12px;
  color: #888;
}
.do-stat-click {
  cursor: pointer;
}
.do-stat-click:hover {
  background: #f5f8fc;
}
.do-stat-bad {
  border-color: #f3c4bd;
  background: #fdecea;
}
.do-stat-bad .do-stat-num {
  color: #c0392b;
}
.do-stat-warn {
  border-color: #f0dcb5;
  background: #fdf7ec;
}
.do-stat-warn .do-stat-num {
  color: #8a6417;
}
.do-columns {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  flex-wrap: wrap;
}
.do-main {
  flex: 1 1 520px;
  min-width: 380px;
}
.do-side {
  flex: 0 0 340px;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.do-section-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  flex-wrap: wrap;
}
.do-chip {
  border-radius: 12px;
  padding: 3px 9px;
  font-size: 12px;
  font-weight: 600;
  background: #eef1f4;
  color: #555;
  white-space: nowrap;
}
.do-chip-ok {
  background: #e8f5e9;
  color: #2e7d32;
}
.do-chip-warn {
  background: #fdf3e0;
  color: #8a6417;
}
.do-chip-off {
  background: #f0f0f0;
  color: #888;
}
.do-chip-bad {
  background: #fdecea;
  color: #c0392b;
}
.do-run {
  border: 1px solid #e3e6ea;
  border-left: 4px solid #d6dbe1;
  border-radius: 8px;
  background: #fff;
  padding: 12px 14px;
  margin-bottom: 10px;
  cursor: pointer;
}
.do-run:hover {
  background: #f8fafc;
}
.do-run-warn {
  border-left-color: #e5a83a;
}
.do-run-ok {
  border-left-color: #2e7d32;
}
.do-run-bad {
  border-left-color: #c0392b;
}
.do-run-off {
  border-left-color: #c8cdd3;
}
.do-run-top {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.do-run-name {
  font-weight: 600;
  font-size: 15px;
}
.do-open {
  font-size: 12px;
  font-weight: 600;
  color: #2f6fd0;
}
.do-run-sub {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  color: #666;
  font-size: 13px;
  margin-top: 4px;
}
.do-mini-icon {
  font-size: 15px;
  width: 15px;
  height: 15px;
  color: #aaa;
}
.do-covering {
  color: #b26a00;
  font-weight: 600;
}
.do-seen {
  color: #2f6fd0;
  text-decoration: underline;
}
.do-seen-stale {
  color: #999;
}
.do-where {
  margin-top: 4px;
  font-size: 13px;
  font-weight: 600;
  color: #2e7d32;
}
.do-run-foot {
  margin-top: 4px;
}
.do-progress {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
}
.do-progress-bar {
  flex: 1 1 auto;
  height: 6px;
  background: #eef1f4;
  border-radius: 3px;
  overflow: hidden;
}
.do-progress-fill {
  height: 100%;
  border-radius: 3px;
  background: #9aa5ae;
  transition: width .3s ease;
}
.do-fill-ok {
  background: #2e7d32;
}
.do-fill-warn {
  background: #e5a83a;
}
.do-fill-bad {
  background: #c0392b;
}
.do-progress-label {
  font-size: 12px;
  font-weight: 600;
  color: #555;
  white-space: nowrap;
}
.do-panel {
  border: 1px solid #e3e6ea;
  border-radius: 8px;
  background: #fff;
  padding: 12px;
}
.do-gen {
  border-top: 1px solid #f0f0f0;
  padding: 8px 0 4px;
}
.do-gen:first-of-type {
  border-top: none;
}
.do-gen-head {
  display: flex;
  align-items: baseline;
  gap: 8px;
  justify-content: space-between;
}
.do-gen-name {
  font-size: 13px;
  font-weight: 600;
}
.do-gen-row {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 4px;
}
.do-gen-driver {
  flex: 1 1 auto;
}
.do-gen-driver .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.do-issue {
  border-top: 1px solid #f0f0f0;
  padding: 8px 0;
  cursor: pointer;
}
.do-issue:first-of-type {
  border-top: none;
}
.do-issue:hover {
  background: #fbfcfd;
}
.do-issue-head {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.do-issue-system {
  font-size: 13px;
  font-weight: 600;
}
.do-issue-note {
  font-size: 12px;
  color: #666;
  margin-top: 2px;
  word-break: break-word;
}
.do-more {
  padding-top: 8px;
}
.do-panel-note {
  margin: 0 0 8px;
  line-height: 1.4;
}
/*# sourceMappingURL=overview.component.css.map */
